import { createFileRoute } from "@tanstack/react-router";

import { SKUStoreDetailPage } from "@/features/SKUStore/SKUStoreDetailPage";

export const Route = createFileRoute("/_auth/sku-store/$siteId/$skuId/")({
  component: SKUStoreDetailPage,
});
